import { render, staticRenderFns } from "./EditMerchantRate.vue?vue&type=template&id=85a07638&"
import script from "./EditMerchantRate.vue?vue&type=script&lang=ts&"
export * from "./EditMerchantRate.vue?vue&type=script&lang=ts&"
import style0 from "./EditMerchantRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditMerchantRate.vue"
export default component.exports